/**
 * Creates a hashmap from an object, where the keys are the paths to the values in the object.
 *
 * @template T - The type of the input object.
 * @param {T} obj - The input object to be converted into a hashmap.
 * @param {Map<string, unknown>} [map=new Map()] - The map to store the key-value pairs.
 * @param {string} [parentKey=''] - The parent key used for nested objects.
 * @returns {Map<string, unknown>} - The resulting hashmap with key-value pairs.
 */
export function createHashMap<T>(
	obj: T,
	map: Map<string, unknown> = new Map(),
	parentKey: string = '',
): Map<string, unknown> {
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			const fullKey = parentKey ? `${parentKey}.${key}` : key;
			const value = (obj as T)[key];
			if (value instanceof Date) {
				map.set(fullKey, value.toISOString());
			} else if (typeof value === 'object' && value !== null) {
				createHashMap(value, map, fullKey);
			} else {
				map.set(fullKey, value);
			}
		}
	}
	return map;
}
